function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));
    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';
    postProcessCallbacks?.forEach((callback) => callback(newNode));
    setTimeout(() => oldNode.remove(), 500);
  }
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    if (button.classList.contains('disabled')) return;

    const previousValue = this.input.value;

    if (button.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && button.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

/**
 * Keeps the first visible grid item at the same visual position while a grid
 * layout changes. The scroll container can be the page or an overflow panel.
 */
window.pcyPreserveGridAnchor = function (grid, applyLayout, scrollContainer) {
  if (!grid || typeof applyLayout !== 'function') {
    if (typeof applyLayout === 'function') applyLayout();
    return;
  }

  var items = Array.from(grid.children).filter(function (item) {
    return item.getClientRects().length > 0;
  });
  var container = scrollContainer && scrollContainer !== window ? scrollContainer : null;
  var containerRect = container ? container.getBoundingClientRect() : null;
  var header = container ? null : document.querySelector('.header-yeni');
  var headerRect = header && header.getClientRects().length ? header.getBoundingClientRect() : null;
  var headerBottom = headerRect ? Math.min(window.innerHeight, Math.max(0, headerRect.bottom)) : 0;

  var toolbar = container ? null : document.querySelector('.list-actions:not(.pcy-toolbar--hidden), .searchContentNav:not(.pcy-toolbar--hidden)');
  var toolbarRect = toolbar && toolbar.getClientRects().length ? toolbar.getBoundingClientRect() : null;
  var toolbarBottom = toolbarRect ? Math.min(window.innerHeight, Math.max(0, toolbarRect.bottom)) : 0;

  var effectiveTopOffset = Math.max(headerBottom, toolbarBottom);
  var viewportTop = containerRect ? containerRect.top : effectiveTopOffset;
  var viewportBottom = containerRect ? containerRect.bottom : window.innerHeight;
  var scrollPosition = container ? container.scrollTop : window.scrollY;
  var savedAnchor = grid.__pcyGridAnchorState;
  // Kullanıcının en çok gördüğü (en yüksek görünür alana sahip veya header altındaki ilk) kartı bul
  var bestAnchor = null;
  var bestVisibleHeight = -1;

  for (var i = 0; i < items.length; i++) {
    var rect = items[i].getBoundingClientRect();
    var visibleTop = Math.max(rect.top, viewportTop);
    var visibleBottom = Math.min(rect.bottom, viewportBottom);
    var visibleHeight = visibleBottom - visibleTop;

    if (visibleHeight > 0) {
      // Eğer öğenin üst kısmı doğrudan viewportTop'ın hemen altındaysa çok yüksek öncelik ver
      var score = visibleHeight;
      if (rect.top >= (viewportTop - 5) && rect.top <= (viewportTop + 150)) {
        score += 1000;
      }
      if (score > bestVisibleHeight) {
        bestVisibleHeight = score;
        bestAnchor = items[i];
      }
    }
  }

  var anchor = (savedAnchor &&
    grid.contains(savedAnchor.item) &&
    Math.abs(savedAnchor.scrollPosition - scrollPosition) < 2)
      ? savedAnchor.item
      : bestAnchor;

  if (!anchor) {
    applyLayout();
    return;
  }

  var initialAnchorRect = anchor.getBoundingClientRect();
  var anchorTop = initialAnchorRect.top;
  applyLayout();

  // Reading the rect forces the new grid layout to resolve synchronously. Apply
  // the scroll correction before the browser paints, otherwise the unanchored
  // layout flashes for one frame between view modes.
  if (!anchor.isConnected) return;

  var newRect = anchor.getBoundingClientRect();
  var delta = newRect.top - anchorTop;

  // Yeni görünümde anchor'ın üst kısmı header/toolbar altında kalıyorsa (rect.top < viewportTop),
  // doğrudan viewportTop hizasına çekerek ürünün asla header arkasına gizlenmemesini sağla.
  var targetScrollDelta = delta;
  var projectedTop = newRect.top - delta;
  if (projectedTop < viewportTop) {
    targetScrollDelta += (projectedTop - viewportTop);
  }

  if (Math.abs(targetScrollDelta) >= 0.5) {
    if (container) {
      container.scrollTop += targetScrollDelta;
    } else {
      window.scrollTo({ top: window.scrollY + targetScrollDelta, left: window.scrollX, behavior: 'instant' });
    }
  }

  grid.__pcyGridAnchorState = {
    item: anchor,
    scrollPosition: container ? container.scrollTop : window.scrollY
  };
};

window.pcyUpdateGridImageSizes = function (grid, view) {
  if (!grid) return;
  if (!view) {
    var surface = grid.closest('[class*="pcy-view--"], [class*="search-overlay__results--view-"], [class*="search-overlay__suggestions--view-"]');
    var match = surface && surface.className.match(/(?:pcy-view--|search-overlay__(?:results|suggestions)--view-)([246])/);
    view = match ? match[1] : '4';
  }
  var sizes = ({
    '2': '(min-width: 990px) 50vw, 100vw',
    '4': '(min-width: 990px) 25vw, 50vw',
    '6': '(min-width: 990px) 16.667vw, 33.333vw'
  })[view];
  grid.querySelectorAll('img.pcy-slide[srcset], img.so-slide[srcset]').forEach(function (image) {
    image.setAttribute('sizes', sizes || '(min-width: 990px) 25vw, 50vw');
  });
};

document.querySelectorAll('.pcy-grid, .search-overlay__product-grid').forEach(function (grid) {
  window.pcyUpdateGridImageSizes(grid);
});

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
    const isIOS = /iP(ad|hone|od)/.test(navigator.platform) ||
                  (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
  
    const afterScrollFlush = (cb) => {
      requestAnimationFrame(() => {
        document.documentElement.getBoundingClientRect();
        requestAnimationFrame(() => setTimeout(cb, 0));
      });
    };
  
    const forceScrollTop = (el) => {
      const target = el || document.scrollingElement || document.documentElement;
  
      const prevBehavior = target.style ? target.style.scrollBehavior : '';
      if (target.style) target.style.scrollBehavior = 'auto';
  
      try {
        if (target === document.documentElement || target === document.body) {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        } else {
          target.scrollTop = 0;
        }
      } catch {
      }
  
      target.getBoundingClientRect();
  
      if (target.style) {
        if (prevBehavior) target.style.scrollBehavior = prevBehavior;
        else target.style.removeProperty('scroll-behavior');
      }
    };
  
    function addTrapFocus() {
      const panel = summaryElement.nextElementSibling;
      if (panel) {
        trapFocus(panel, detailsElement.querySelector('button'));
        panel.removeEventListener('transitionend', addTrapFocus);
      }
    }
  
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
  
      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
      return;
    }
  
    event.preventDefault();
  
    if (!isOpen) {
      const mainScrollContainer = document.querySelector('.mobile-facets__main');
      if (mainScrollContainer) {
        forceScrollTop(mainScrollContainer);
      } else {
        forceScrollTop(document.documentElement);
      }
  
      afterScrollFlush(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', 'true');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
  
        setTimeout(() => {
          detailsElement.setAttribute('open', '');
  
          const panel = summaryElement.nextElementSibling;
          if (!prefersReduced && panel) {
            panel.addEventListener('transitionend', addTrapFocus, { once: true });
          } else {
            addTrapFocus();
          }
        }, isIOS ? 80 : 60);
      });
    } else {
      detailsElement.removeAttribute('open');
      detailsElement.classList.remove('menu-opening');
      summaryElement.setAttribute('aria-expanded', 'false');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    }
  }
  
  
  

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const bindClose = () => {
      const closeEl = this.querySelector('[id^="ModalClose-"]');
      if (closeEl && !closeEl.__wired) {
        closeEl.addEventListener('click', this.hide.bind(this, false));
        closeEl.__wired = true;
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindClose, { once: true });
    } else {
      requestAnimationFrame(bindClose);
    }
    this.addEventListener('keyup', (event) => {
      const code = (event.code || event.key || '').toUpperCase();
      if (code === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        const clickedInsideInteractive = event.target.closest(
          'deferred-media, product-model, .media-modal__main, .swiper, .swiper-wrapper, .swiper-slide, .swiper-zoom-container, .media-modal__thumbnails'
        );
        if (!clickedInsideInteractive) {
          this.hide();
        }
      });
      this.addEventListener(
        'click',
        (event) => {
          const clickedInsideInteractive = event.target.closest(
            'deferred-media, product-model, .media-modal__main, .swiper, .swiper-wrapper, .swiper-slide, .swiper-zoom-container, .media-modal__thumbnails'
          );
          if (!clickedInsideInteractive) {
            this.hide();
          }
        },
        { passive: true }
      );
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    if (this.id === 'SizeGuideModal' && !this.hasAttribute('data-user-opened')) {
      this.removeAttribute('open');
    }
    const mainArea = this.querySelector('.product-media-modal__toggle');
    if (mainArea && mainArea.getAttribute('onclick')) {
      mainArea.removeAttribute('onclick');
    }
    document.body.appendChild(this);
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    if (this.id === 'SizeGuideModal') this.setAttribute('data-user-opened', '');
    this.setAttribute('open', '');
    if (popup && typeof popup.loadContent === 'function') {
      popup.loadContent();
    }
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia?.();
  }
  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    if (this.id === 'SizeGuideModal') this.removeAttribute('data-user-opened');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia?.();
  }
}

if (!customElements.get('modal-dialog')) {
  customElements.define('modal-dialog', ModalDialog);
}

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider || document.body.clientWidth > 768) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        ?.removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
         const productData = [];
         html.querySelectorAll('.grid__item').forEach((item) => {
           productData.push({
             title: item.querySelector('.product-title')?.innerText || 'Unknown',
             price: item.querySelector('.product-price')?.innerText || 'Unknown',
             image: item.querySelector('img')?.src || '',
             link: item.querySelector('a')?.href || '#',
           });
         });
 
         window.productRecommendations = productData;
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}


// Legacy filter controller yalnız eski filtre butonları içindir. Modern PCY
// collection/search butonlarının kendi scoped controller'ları var; bunları
// burada da bağlamak modal tıklamasında ikinci drawer'ı açıyordu.
if (document.querySelector('.btn-filter:not(.pcy-filter-btn)')) {
  let facetsWrapper = document.querySelector('.facets-wrapper');
  let btnFilter = document.querySelector('.btn-filter:not(.pcy-filter-btn)');

  function lockScroll() {
    if (window.matchMedia('(max-width: 989px)').matches) {
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
    }
  }
  function unlockScroll() {
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
  }

  btnFilter.addEventListener('click', function () {
    facetsWrapper.classList.add('active');
    btnFilter.classList.add('active');
    lockScroll();
  });

  document.querySelector('.btn-filter-close').addEventListener('click', function () {
    facetsWrapper.classList.remove('active');
    btnFilter.classList.remove('active');
    unlockScroll();
  });
  document.querySelector('.btn-filter-apply').addEventListener('click', function () {
    facetsWrapper.classList.remove('active');
    btnFilter.classList.remove('active');
    unlockScroll();
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.facets-wrapper') && !event.target.closest('.btn-filter')) {
      facetsWrapper.classList.remove('active');
      btnFilter.classList.remove('active');
      unlockScroll();
    }
  });
}



if (document.querySelector('.btn-sort')) {
  let btnSort = document.querySelector('.btn-sort');
  btnSort.addEventListener('click', function () {
    document.querySelector('.facets-sort').classList.add('active');
    btnSort.classList.add('active');
  });

  document.querySelector('.btn-sort-close').addEventListener('click', function () {
    document.querySelector('.facets-sort').classList.remove('active');
    btnSort.classList.remove('active');
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.facets-sort') && !event.target.closest('.btn-sort')) {
      document.querySelector('.facets-sort').classList.remove('active');
      btnSort.classList.remove('active');
    }
  });

  const urlParams = new URLSearchParams(window.location.search);
  const sortBy = urlParams.get('sort_by');

  if (sortBy) {
    let selectElement = document.querySelector('select[name="sort_by"]');
    let optionToSelect = selectElement.querySelector(`option[value="${sortBy}"]`).innerText;
    if (optionToSelect) {
      const sortButton = document.querySelector('.btn-sort > span');
      sortButton.innerHTML = "<b>"+optionToSelect+"</b>";
    }
  }

}
let layoutView = () => {
  const productList = document.getElementById('product-grid');

  document.querySelectorAll('.btn-layout').forEach((btn) => {
    btn.addEventListener('click', function () {

      document.querySelectorAll('.btn-layout.active').forEach((btn) => {
        btn.classList.remove('active');
      });

      this.classList.add('active');
      let layout = this.dataset.layout;
      if (layout == 'grid') {
        productList.classList.add('grid--4-col-desktop');
        productList.classList.remove('grid--2-col-desktop');
        localStorage.setItem('productListView', 'grid--4-col-desktop');
      }
      else if (layout == 'list') {
        productList.classList.remove('grid--4-col-desktop');
        productList.classList.add('grid--2-col-desktop');
        localStorage.setItem('productListView', 'grid--2-col-desktop');
      }
      else if (layout == 'two-column') {
        productList.classList.remove('grid--1-col-tablet-down');
        productList.classList.add('grid--2-col-tablet-down');
        localStorage.setItem('productListView', 'grid--2-col-tablet-down');
      }
      else if (layout == 'single-column') {
        productList.classList.remove('grid--2-col-tablet-down');
        productList.classList.add('grid--1-col-tablet-down');
        localStorage.setItem('productListView', 'grid--1-col-tablet-down');
      }
    });
  });

    if (productList.classList.contains('grid--4-col-desktop')) {
      if(document.querySelector('.btn-layout[data-layout="grid"]') || document.querySelector('.btn-layout[data-layout="list"]')){
        document.querySelector('.btn-layout[data-layout="grid"]').classList.add('active');
        document.querySelector('.btn-layout[data-layout="list"]').classList.remove('active');
      }
    }
    else if (productList.classList.contains('grid--2-col-desktop')) {
      document.querySelector('.btn-layout[data-layout="list"]').classList.add('active');
      document.querySelector('.btn-layout[data-layout="grid"]').classList.remove('active');
    }
    if (productList.classList.contains('grid--2-col-tablet-down')) {
      productList.classList.remove('grid--1-col-tablet-down');
      document.querySelector('.btn-layout[data-layout="two-column"]').classList.add('active');
      document.querySelector('.btn-layout[data-layout="single-column"]').classList.remove('active');
    }
    else if (productList.classList.contains('grid--1-col-tablet-down')) {
      productList.classList.remove('grid--2-col-tablet-down');
      document.querySelector('.btn-layout[data-layout="single-column"]').classList.add('active');
      document.querySelector('.btn-layout[data-layout="two-column"]').classList.remove('active');
    }
}
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.btn-layout')) {
    layoutView();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.swiper-pagination')|| e.target.closest('.swiper-pagination-bullet')) {
      console.log("stopped")
      e.stopPropagation();
    }
  });

});


class SwiperContainer extends HTMLElement {
  defaultOptions;
  constructor() {
    super();

    this.defaultOptions = {
      loop: false,
      autoplay: false,
      spaceBetween: '0',
      navigation: false,
      slidesPerView: 1,
      pagination: false,
      centeredSlides: false,
      direction: 'horizontal',
      loopedSlides: 1,
      slideToClickedSlide: false,
      thumbs: false,
      watchSlidesProgress: false,
      breakpoints: false,
      slidesPerGroup: 1,
      delay: 2000,
      initialSlide: 0,
    };

    this.init();

  }

  init = () => {
    let el = this.querySelector('.swiper');
    let options = this.getOptions();

    if (!el) return;
    const isRTL = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
    el.setAttribute('dir', isRTL ? 'rtl' : 'ltr');

    this.swiper = new Swiper(el, options)

    if (this.querySelector('[data-fancybox]')) {
      window.Fancybox.bind('[data-fancybox]', {
        Images: {
          zoom: false
        },
        Toolbar: {
          display: {
            left: ['infobar'],
            middle: [
              'zoomIn',
              'zoomOut'
            ],
            right: ['fullscreen', 'thumbs', 'close', 'counter']
          }
        },
        Thumbs: {
          type: 'classic'
        },
        on: {
          close: (fancybox, slide) => {
            const index = fancybox.getSlide().index
            this.swiper.slideToLoop(index)
          }
        }
      })

    }
  }

  getOptions = () => {
    let options = {};
    for (let key in this.defaultOptions) {
      let value = this.getAttribute(this.camelCaseToKebabCase(key));
      if (value !== null) {


        if (key == 'navigation' && value === 'true') {
          options[key] = {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          };
        }
        else if (key == 'pagination' && value === 'true') {
          options[key] = {
            el: '.swiper-pagination',
            clickable: true,
          };
        }
        else if (key == 'thumbs') {
          options[key] = {
            swiper: document.querySelector(value).querySelector('.swiper'),
          };
        }
        else if (key == 'delay') {
          if (options['autoplay'])
            options['autoplay'] = { delay: value }
        }
        else if (key == 'breakpoints') {
          let breakpoints = {}
          this.breakpoints = Array.from(this.querySelectorAll('breakpoint'))
            .filter((item) => item.nodeName.toLowerCase() === 'breakpoint')
            .map((breakpoint) => {
              let subOptions = {};
              for (let subKey in this.defaultOptions) {
                let value = breakpoint.getAttribute(this.camelCaseToKebabCase(subKey));

                if (value !== null) {
                  if (typeof this.defaultOptions[subKey] === 'boolean') {
                    if (typeof value === 'undefined') {
                      subOptions[subKey] = false;
                    } else {
                      subOptions[subKey] = (!(String(value).toLowerCase() === 'false') || value === '');
                    }
                  }
                  else if (typeof this.defaultOptions[subKey] === 'number') {
                    subOptions[subKey] = parseFloat(value);
                  }
                  else {
                    subOptions[subKey] = value;
                  }
                }
              }
              let size = breakpoint.getAttribute('size');
              breakpoints[size] = subOptions;
            });

          options[key] = breakpoints;

        }
        else if (typeof this.defaultOptions[key] === 'boolean') {
          if (typeof value === 'undefined') {
            options[key] = false;
          } else {
            options[key] = (!(String(value).toLowerCase() === 'false') || value === '');
          }
        }
        else if (typeof this.defaultOptions[key] === 'number') {
          options[key] = parseFloat(value);
        }
        else {
          options[key] = value;
        }
      }
    }
    return options;
  }

  slideTo = (n) => {
    this.swiper.slideTo(n);
  }

  slideToLoop = (n) => {
    this.swiper.slideToLoop(n);
  }

  camelCaseToKebabCase = (str) => str
    .split('')
    .map((letter, index) => (letter.toUpperCase() === letter
      ? `${index === 0 ? '' : '-'}${letter.toLowerCase()}`
      : letter))
    .join('');
}
customElements.define('swiper-container', SwiperContainer);
let collectionAddToCartRegistered = false;
let collectionAddToCart = () => {
  if (collectionAddToCartRegistered) return;
  collectionAddToCartRegistered = true;

  // RTL/Arapça desteği için dil kontrolü
  const isArabicGlobal = document.documentElement.lang?.startsWith('ar') || document.documentElement.dir === 'rtl';
  const toastPositionGlobal = isArabicGlobal ? 'left' : 'right';

  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('card__variant-item')) {
      // Öneri/related-products section'larının kendi handler'ları var — çift add'i önle
      if (e.target.closest('#shopify-section-related-products, #shopify-section-related-products-2, #shopify-section-related-products-2-copy, #shopify-section-custom-newest, product-recommendations')) return;

      // Stok durumunu kontrol et
      const isAvailable = e.target.getAttribute('data-available');
      const hasOutOfStockClass = e.target.classList.contains('out-of-stock');

      // Debug için console log (production'da kaldırılabilir)
      console.log('Variant clicked:', {
        available: isAvailable,
        hasOutOfStockClass: hasOutOfStockClass,
        variantId: e.target.dataset.variantId
      });

      // Stokta yoksa işlemi durdur
      if (hasOutOfStockClass || isAvailable === 'false') {
        Toastify({
          text: `<img src="https://cdn.shopify.com/s/files/1/0646/0833/8075/files/allert.svg?v=1733225445" class="toastify-icon" width="20px" /> ${window.themeTranslations.backInStock}`,
          duration: 2000,
          className: 'stock-alert-container',
          style: {
            background: "#000",
            color: "#fff",
          },
          escapeMarkup: false,
          newWindow: true,
          close: false,
          gravity: "top",
          position: toastPositionGlobal,
          stopOnFocus: true,
          onClick: function () { }
        }).showToast();
        return; // Stokta yoksa hiç devam etme
      }

      let productName = e.target.dataset.productName;
      let productVariant = e.target.dataset.productVariant;
      let productImage = e.target.dataset.productImage;
      let variantId = e.target.dataset.variantId;

      const cartUrl = window.localeData.isDefault
        ? '/cart'
        : `/${window.localeData.current}/cart`;

      var template = document.createElement("div");
      template.innerHTML = `
        <div class="messsage add-to-cart-message">
          <div class="top">
            <span>
              <img style="width: 15px" src="https://cdn.shopify.com/s/files/1/0646/0833/8075/files/add-to-cart-tik.png?v=1739879167" alt="tick">
            </span>
            ${window.themeTranslations.itemAdded}
          </div>
          <div class="middle">
            <div class="left">
                <img width="75" height="90" alt="${productName}" src="${productImage}">
            </div>
            <div class="message__right">
                <div class="product-title">${productName}</div>
                <span>${productVariant}</span>
            </div>
          </div>
          <div class="bottom">
            <a href="${cartUrl}">
              ${window.themeTranslations.goCart}
            </a>
          </div>
        </div>
      `;
      let formData = {
        'items': [{
          'id': variantId,
          'quantity': 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(errorData => {
              throw errorData;
            });
          }
          return response.json();
        })
        .then(data => {
          // Stok kontrolü tarafından engellendiyse başarı mesajı gösterme
          if (data.__stockBlocked || data.__wishlistStockBlocked || window.__wishlistPreBlocked) {
            console.log('PLP: Stock blocked, skipping success toast');
            return;
          }

          const bubbles = document.querySelectorAll('.cart-count-bubble, .desktop-cart-count-bubble');
          bubbles.forEach(function(bubble) {
            let numSpan = bubble.querySelector('span[aria-hidden="true"]');
            const currentCount = numSpan ? (parseInt(numSpan.textContent, 10) || 0) : 0;
            const newCount = currentCount + 1;
            if (!numSpan) {
              numSpan = document.createElement('span');
              numSpan.setAttribute('aria-hidden', 'true');
              bubble.prepend(numSpan);
            }
            numSpan.textContent = String(newCount);
            bubble.style.display = 'block';
            const hiddenSpan = bubble.querySelector('.visually-hidden');
            if (hiddenSpan) hiddenSpan.textContent = newCount;
          });
          // Server'dan gerçek sayıyı çekip teyit et (HTML overwrite riski olmaz)
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var serverCount = cart.item_count;
              if (serverCount > 0) {
                document.querySelectorAll('.cart-count-bubble, .desktop-cart-count-bubble').forEach(function(b) {
                  var s = b.querySelector('span[aria-hidden="true"]');
                  if (!s) {
                    s = document.createElement('span');
                    s.setAttribute('aria-hidden', 'true');
                    b.prepend(s);
                  }
                  s.textContent = String(serverCount);
                  b.style.display = 'block';
                  var h = b.querySelector('.visually-hidden');
                  if (h) h.textContent = serverCount;
                });
              }
            })
            .catch(function() {});
          window.removableToastify = Toastify({
            node: template,
            duration: 2000,
            className: "add-to-cart-message-wrapper",
            newWindow: true,
            close: true,
            gravity: "top",
            position: toastPositionGlobal,
            stopOnFocus: true,
            onClick: function () { },
            onClose: function () {
              template.remove();
            }
          }).showToast();
        })
        .catch(error => {
          // Stok hatası mesajını göster - API'den dönen gerçek mesaj
          console.error('PLP Add to cart error:', error);
          const errorMsg = error?.description || error?.message || window.themeTranslations?.addToCartError || 'Could not add to cart';

          // Başarı mesajını kapat (eğer gösterildiyse)
          if (window.removableToastify) {
            window.removableToastify.hideToast();
          }

          Toastify({
            text: `<img src="https://cdn.shopify.com/s/files/1/0646/0833/8075/files/allert.svg?v=1733225445" class="toastify-icon" width="20px" /> ${errorMsg}`,
            duration: 3000,
            className: 'stock-alert-container',
            style: {
              background: "#000",
              color: "#fff",
            },
            escapeMarkup: false,
            newWindow: true,
            close: false,
            gravity: "top",
            position: toastPositionGlobal,
            stopOnFocus: true,
            onClick: function () { }
          }).showToast();
        });
    }
  });
};

if (document.querySelector('.card__variant-item')) {
  collectionAddToCart();
}


const sectionsToRender = ['cart-icon-bubble'];

async function getSectionsToRender(sectionIds) {
  const url = `/sections?sections=${sectionIds.join(',')}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    sectionIds.forEach(id => {
      const sectionElement = document.querySelector(`#${id}`);
      if (sectionElement) {
        sectionElement.innerHTML = data[id];
      }
    });
  } catch (error) {
    console.error('Error fetching sections:', error);
  }
}


document.addEventListener("facetFiltersFormSubmit", () => {
  collectionAddToCart();
  layoutView();
});

document.querySelector('.size-chart')?.addEventListener('click', function () {
  const link = document.querySelector('.goodsc-float-btn');
  if (link) {
      link.click();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const summaries = document.querySelectorAll('.menu-drawer__navigation > ul > li > details > summary');
  summaries.forEach(summary => {
    summary.addEventListener('click', function() {
      const firstLevelDetails = document.querySelectorAll('.menu-drawer__navigation > ul > li > details');
      firstLevelDetails.forEach(detail => {
        detail.removeAttribute('open');
      });
      const details = summary.closest('details');
      if (details && details.closest('ul') && !details.closest('ul').closest('ul')) {
        details.setAttribute('open', 'true');
      }
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('.product-media-modal');
  const cartIcons = document.querySelectorAll('.header__icon--cart');
  const stickyHeader = document.querySelector('sticky-header');
  if (!modal) return;
  function setPointerState(disabled) {
    const state = disabled ? 'none' : 'auto';
    cartIcons.forEach(icon => icon.style.pointerEvents = state);
    if (stickyHeader) stickyHeader.style.pointerEvents = state;
  }
  setPointerState(modal.hasAttribute('open'));
  let timeoutId;
  const observer = new MutationObserver(() => {
    if (modal.hasAttribute('open')) {
      clearTimeout(timeoutId);
      setPointerState(true);
    } else {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setPointerState(false), 250);
    }
  });
  observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
});
